module.exports = __webpack_public_path__ + "img/bannerbg5.ce49353c.png";